import axios from "axios";
import _ from "lodash";
const currentUrl = `${window.location.protocol}//${window.location.host}`;

let isLive = false;
const env = process.env.REACT_APP_ENV;

let _baseURL = "";
let _stripeKey = "";
let _documentURL = "";

switch (env) {
  case "live":
    isLive = true;
    _baseURL = process.env.REACT_APP_BASE_URL;
    //_stripeKey = 'pk_live_51MzAu1Hm19PZigrAxWqHwGVWNdkesolZmiEiYOGKr4wiEH9KHEJKD5LPz2nxhHkpvCmsmIz0r1XSij3Pmv6P2Y6S00WmZKa0Om';
    _stripeKey = process.env.REACT_APP_STRIPE_KEY;
    _documentURL = process.env.REACT_APP_DOCUMENT_URL;
    break;
  case "staging":
    isLive = false;
    _baseURL = process.env.REACT_APP_BASE_URL;
    _stripeKey = process.env.REACT_APP_STRIPE_KEY;
    _documentURL = process.env.REACT_APP_DOCUMENT_URL;
    break;
  case "development":
    isLive = false;
    _baseURL = process.env.REACT_APP_BASE_URL;
    _stripeKey = process.env.REACT_APP_STRIPE_KEY;
    _documentURL = process.env.REACT_APP_DOCUMENT_URL;
    break;
  default:
    isLive = false;
    _baseURL = `http://localhost:8000/`;
    _stripeKey =
      "pk_test_51Hh5rVAWqIpRaeXeLS0OK5TGFs4VDTgdJXUYOODZT5lkFOy5frhReIn4ng3UTJ1KImQmaqqylptpXTybgUgcgMO100pkFYywfu";
    _documentURL = `https://api.wlms.archnix.dev`;
}

export const baseURL = _baseURL;
export const stripeKey = _stripeKey;
export const documentURL = _documentURL;

//!important this need to change with live url deploy to live
export const baseappURL = process.env.REACT_APP_BASE_APP_URL; //isLive ?  `https://live.wlms.archnix.dev` : `https://staging.wlms.archnix.dev`  ;
  
export default class Repository {
  url = `${baseURL}api/v1/`;
  IMAGE_URL = `${baseURL}storage/`;

  data = async (method, path, data = null, user_token = "") => {
    let access_token = localStorage.getItem("token");
    if (_.isNull(access_token)) {
      access_token = "";
    }
    console.log(path, "currentserver :", currentUrl);
    const token = "";
    return axios({
      method: method,
      url: this.url + path + (path.includes("?") ? "&v=1" : "?v=1"),
      data: data,
      headers: {
        Authorization:
          access_token.length > 0 ? `Bearer ${access_token}` : `Bearer`,
        Accept: "application/json",
      },
    })
      .then((response) => response)
      .catch((e) => {
        return e.response;
      });
  };

  pathData = async (method, path, data = null, user_token = "") => {
    let access_token = localStorage.getItem("token");
    if (_.isNull(access_token)) {
      access_token = "";
    }
    console.log(path, "currentserver :", currentUrl);
    const token = "";
    return axios({
      method: method,
      url: this.url + path,
      data: data,
      headers: {
        Authorization:
          access_token.length > 0 ? `Bearer ${access_token}` : `Bearer`,
        Accept: "application/json",
      },
    })
      .then((response) => response)
      .catch((e) => {
        return e.response;
      });
  };

  getAxios = async (path) => {
    return axios.get(path);
  };

  getData = (path, data, token = "") => {
    return this.data("get", path, data, token);
  };

  fetchdata = (path, data, token = "") => {
    return this.pathData("get", path, data, token);
  };

  postData = (path, data, token = "") => {
    return this.data("post", path, data, token);
  };

  putData = (path, data, token = "") => {
    return this.data("put", path, data, token);
  };

  deleteData = (path, data, token = "") => {
    return this.data("delete", path, data, token);
  };

  patchData = (path, data, token = "") => {
    return this.data("patch", path, data, token);
  };

  uploadForm = async (path, fd, user_token = "") => {
    const token = localStorage.getItem("token");
    if (_.isNull(token)) {
      token = "";
    }
    const url = this.url + path + (path.includes("?") ? "&v=1" : "?v=1");
    try {
      const response = await axios.post(url, fd, {
        headers: {
          Authorization: token.length > 0 ? `Bearer ${token}` : `Bearer`,
          Accept: "application/json",
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  };
}
